export default __webpack_public_path__ + "static/media/f3.a19265e4.jpg";